import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AccountSettings from "./AccountSettings";
import { useIsOwner, useMe, useMyOrganization } from "../shared/Me/useMe";
import { Box } from "@chakra-ui/react";
import { OrganizationSettings } from "./OrganizationSettings";
import { UsageSettings } from "./UsageSettings";
import { MemberSettings } from "./MemberSettings";
import "./Settings.css";
import { APIKeysForProjectsMembers } from "../APIKeys/APIKeysForProjectsMembers";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FEATURE_FLAG } from "../App/featureFlags.js";
import { PageContainer } from "../shared/PageContainer/index.js";
import "./Settings.css";
export const Settings = () => {
  const { isLoading } = useMe();
  const organization = useMyOrganization();
  const isOwner = useIsOwner();
  const flags = useFlags();
  const showBillingEngine = flags[FEATURE_FLAG.BILLING_ENGINE_MVP];
  if (isLoading) return null;
  return /* @__PURE__ */ React.createElement(PageContainer, null, /* @__PURE__ */ React.createElement(Box, { p: ["16px", null, "24px"], className: "Settings" }, /* @__PURE__ */ React.createElement(Routes, null, /* @__PURE__ */ React.createElement(
    Route,
    {
      exact: true,
      path: "/account",
      element: /* @__PURE__ */ React.createElement(AccountSettings, null)
    }
  ), /* @__PURE__ */ React.createElement(
    Route,
    {
      exact: true,
      path: "/keys",
      element: /* @__PURE__ */ React.createElement(APIKeysForProjectsMembers, null)
    }
  ), (organization !== "com.quantumbasel" || organization === "com.quantumbasel" && isOwner) && /* @__PURE__ */ React.createElement(
    Route,
    {
      exact: true,
      path: "/members",
      element: /* @__PURE__ */ React.createElement(MemberSettings, null)
    }
  ), isOwner && showBillingEngine ? /* @__PURE__ */ React.createElement(
    Route,
    {
      exact: true,
      path: "/settings",
      element: /* @__PURE__ */ React.createElement(OrganizationSettings, null)
    }
  ) : /* @__PURE__ */ React.createElement(
    Route,
    {
      path: "/settings",
      element: /* @__PURE__ */ React.createElement(Navigate, { to: "/jobs", replace: true })
    }
  ), isOwner ? /* @__PURE__ */ React.createElement(
    Route,
    {
      exact: true,
      path: "/spend",
      element: /* @__PURE__ */ React.createElement(UsageSettings, null)
    }
  ) : /* @__PURE__ */ React.createElement(
    Route,
    {
      path: "/spend",
      element: /* @__PURE__ */ React.createElement(Navigate, { to: "/jobs", replace: true })
    }
  ))));
};
